var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming-soon-layout"},[_c('div',{staticClass:"coming-soon"},[_c('p',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Coming soon to this slide!')))]),_c('p',[_vm._v(_vm._s(_vm.$i18nPresenter.t('In the meantime, try enhancing your Content slides with this exciting feature 🤩')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }